import React, { useEffect, useState } from "react";
import "./Order_Details.css";
import { Link } from "react-router-dom";
import Blue_Btn from "../../../common-components/common_btn/blue_btn/Blue_Btn";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Brown_btn from "../../../common-components/common_btn/brown_btn/Brown_btn";
import Cancel_Reason_Modal from "../../../common-components/common_modal/cancel_reason_modal/Cancel_Reason_Modal";
import { useDispatch, useSelector } from "react-redux";
import { cancelOrder, getOrder } from "../../../../features/order/orderSlice";
import { encodeId, OrderStatusIds } from "../../../../utils/common";
import { getAllCancelReason } from "../../../../features/master/masterSlice";
import Success_Modal_LogOut from "../../../common-components/common_modal/success_modal/Success_Modal_logOut";
import { useNavigate } from "react-router-dom";
import Delete_Modal from "../../../common-components/common_modal/delete_modal/Delete_Modal";

const Order_Details = ({
  selectedOrder,
  showBackButton,
  goBack,
  showCheckBox = false,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [cancelReason, setCancelReason] = useState(null);
  const [otherReason, setOtherReason] = useState("");
  const navigate = useNavigate();
  const [error, setError] = useState("");

  const [selectedProducts, setSelectedProducts] = useState([]);

  const handleProductCheckbox = (product, checked) => {
    setSelectedProducts((prev) => {
      if (checked) {
        if (prev.some((item) => item.id === product.id)) {
          return prev;
        }

        return [...prev, product];
      }

      return prev.filter((item) => item.id !== product.id);
    });
  };

  const [showSuccess, setShowSuccess] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [successText, setSuccessText] = useState("");

  const dispatch = useDispatch();

  const order = useSelector((state) => state.order.order);

  const cancelReasons = useSelector((state) => state.master.cancelReasons);

  useEffect(() => {
    dispatch(getAllCancelReason());
  }, [dispatch]);

  const fetch = async (selectedOrder) => {
    await dispatch(
      getOrder({
        id: selectedOrder?.id,
        order_status_id: selectedOrder.order_status_id,
      }),
    );
  };

  useEffect(() => {
    if (selectedOrder) {
      fetch(selectedOrder);
    }
  }, [dispatch, selectedOrder]);

  const cancelFinalFunction = async () => {
    if (selectedProducts.length === 0) {
      setShowDelete(true);
      setSuccessText("Please select at least one product to cancel.");
      return;
    }

    if (!cancelReason) {
      setShowDelete(true);
      setSuccessText("Please select cancel reason");
      setTimeout(() => {
        setShowDelete(false);
      }, 2000);
      return;
    }

    // OTHER VALIDATION
    if (cancelReason === "other" && !otherReason?.trim()) {
      setShowDelete(true);
      setSuccessText("Please enter reason");

      setTimeout(() => {
        setShowDelete(false);
      }, 2000);

      return;
    }

    try {
      const datafinal = {};

      if (cancelReason && cancelReason !== "other") {
        datafinal.cancel_reason_id = cancelReason;
      }

      if (cancelReason === "other" && otherReason?.trim()) {
        datafinal.message = otherReason.trim();
      }

      if (selectedProducts.length > 0) {
        datafinal.products = selectedProducts;
      }

      const res = await dispatch(
        cancelOrder({ order_id: order?.id, data: datafinal }),
      );

      if (res.meta?.requestStatus === "fulfilled") {
        setShowModal(false);
        setSuccessText("Order cancelled successfully");
        setShowSuccess(true);
        setTimeout(() => {
          setShowSuccess(false);
          navigate("/");
        }, 2000);

        // RESET STATES
        setCancelReason(null);
        setOtherReason("");
      } else if (res.meta?.requestStatus === "rejected") {
        setShowDelete(true);
        setSuccessText(res?.payload?.errors || "Something went wrong");
        setTimeout(() => {
          setShowDelete(false);
        }, 2000);
      }
    } catch (error) {
      setShowDelete(true);
      setSuccessText(error?.message || "Something went wrong");
      setTimeout(() => {
        setShowDelete(false);
      }, 2000);
    } finally {
    }
  };

  return (
    <section className="Order_Details">
      <div className="back_main_div">
        <button className="back_btn" onClick={goBack}>
          <FontAwesomeIcon icon={faArrowLeft} /> Back
        </button>
      </div>
      <div className="row">
        <div className="col-lg-7">
          <div className="details_main_div">
            {order?.Product_Order_Details?.map((data, index) => {
              const isProductUnavailable =
                data?.Product?.deletedAt || !data?.Product?.status;

              return (
                <Link
                  to={
                    isProductUnavailable
                      ? ""
                      : `/product-details/${encodeId(data?.Product?.id)}`
                  }
                  className="detail_top_div"
                >
                  {" "}
                  <div className="detail_top_img">
                    {" "}
                    {showCheckBox && (
                      <div className="product_checkbox">
                        {" "}
                        <input
                          type="checkbox"
                          className="form-check-input"
                          checked={selectedProducts.some(
                            (item) => item.id === data.id,
                          )}
                          onChange={(e) => {
                            e.stopPropagation();
                            handleProductCheckbox(data, e.target.checked);
                            setError("");
                          }}
                          onClick={(e) => e.stopPropagation()}
                        />
                      </div>
                    )}
                    <div className="detail_img">
                      {" "}
                      <img
                        src={
                          process.env.REACT_APP_IMG_URL + data?.Product?.image
                        }
                        className="top_img"
                        alt="product_img"
                      />{" "}
                    </div>{" "}
                    <p className="top_text">
                      {" "}
                      {data?.Product?.name} -{" "}
                      {data?.Product_Variant?.Metal?.name || ""}{" "}
                      {data?.Product?.Unit?.name || ""}{" "}
                    </p>{" "}
                  </div>{" "}
                  <p className="quantity">x{data?.quantity || ""}</p>{" "}
                </Link>
              );
            })}

            <div className="dark_div">
              <p className="dark_text">
                <span className="label">Street: </span>{" "}
                <span className="value"> {order?.User_Address?.building}</span>
              </p>

              <p className="dark_text">
                <span className="label"> City:</span>{" "}
                <span className="value">
                  {order?.User_Address?.Users_Address_Detail?.City?.name || ""}
                </span>
              </p>

              <p className="dark_text">
                <span className="label">State:</span>{" "}
                <span className="value">
                  {" "}
                  {order?.User_Address?.Users_Address_Detail?.State?.name || ""}
                </span>
              </p>

              <p className="dark_text">
                <span className="label">Pincode:</span>{" "}
                <span className="value">
                  {" "}
                  {order?.User_Address?.Users_Address_Detail?.Pincode?.name ||
                    ""}
                </span>
              </p>
              {order?.Order_Cancellation && (
                <p className="dark_text">
                  <span className="label">Cancel Reason :</span>{" "}
                  <span className="value">
                    {order?.Order_Cancellation?.Cancel_Reason?.name ??
                      order?.Order_Cancellation?.message ??
                      ""}
                  </span>
                </p>
              )}
              {order?.Order_Rejection && (
                <p className="dark_text">
                  <span className="label">Reject Reason :</span>{" "}
                  <span className="value">
                    {order?.Order_Rejection?.message ?? ""}
                  </span>
                </p>
              )}
            </div>

            {!showBackButton &&
              Number(order?.order_status_id) <
                Number(OrderStatusIds.Preparing) && (
                <div className="btn_holder">
                  <Brown_btn
                    btnText="Cancel Order"
                    onClick={() => {
                      if (selectedProducts.length === 0) {
                        setShowDelete(true);
                        setSuccessText(
                          "Please select at least one product to cancel.",
                        );
                        return;
                      }
                      setShowModal(true);
                    }}
                  />
                </div>
              )}
          </div>
        </div>

        <div className="col-lg-5 summary-card">
          <div className="details_main_div">
            <p className="right_title">Payment Summary</p>

            <div className="total_div">
              <p className="sub_text">Subtotal</p>
              <p className="sub_number">
                ₹{Number(order?.total_selling_price || 0).toFixed(2)}
              </p>
            </div>

            <div className="total_div ">
              <p className="sub_text">Shipping</p>
              <p className="sub_number">
                ₹{Number(order?.delivery_charges || 0).toFixed(2)}
              </p>
            </div>
            <div className="total_div ">
              <p className="sub_text">Offer Discount</p>
              <p className="sub_number">
                ₹{(Number(order?.total_offer_discount) || 0).toFixed(2)}
              </p>
            </div>
            <div className="total_div ">
              <p className="sub_text">Coupon Discount</p>
              <p className="sub_number">
                ₹{(Number(order?.total_coupon_discount) || 0).toFixed(2)}
              </p>
            </div>
            <div className="total_div ">
              <p className="sub_text">Tax</p>
              <p className="sub_number">
                ₹{(Number(order?.total_tax) || 0).toFixed(2)}
              </p>
            </div>

            <div className="last_div">
              <p className="sub_text">Total</p>
              <p className="sub_number">
                ₹{Number(order?.total_amount || 0).toFixed(2)}
              </p>
            </div>
          </div>
        </div>
      </div>{" "}
      <Cancel_Reason_Modal
        cancelReason={cancelReason}
        setCancelReason={setCancelReason}
        otherReason={otherReason}
        cancelReasons={cancelReasons}
        setOtherReason={setOtherReason}
        onCancel={() => setShowModal(false)}
        show={showModal}
        onHide={() => setShowModal(false)}
        onSaveExit={() => {
          cancelFinalFunction();
        }}
      />
      <Success_Modal_LogOut
        show={showSuccess}
        onHide={() => {
          setShowSuccess(false);
        }}
        successText={successText}
      />
      <Delete_Modal
        show={showDelete}
        onHide={() => {
          setShowDelete(false);
        }}
        successText={successText}
      />
    </section>
  );
};

export default Order_Details;
